import { Either, Left, Right } from "core/types/Either";
import { FeatureFlag } from "domain/entity/FeatureFlag";
import { IFeatureFlagRepository } from "domain/repository/IFeatureFlagRepository";
import { AmplitudeExperimentDataSource } from "data/dataSource/AmplitudeExperimentDataSource";
import { VARIANT_TREATMENT } from "core/constants/experiments";

export class FeatureFlagRepositoryImpl extends IFeatureFlagRepository {
  private dataSource: AmplitudeExperimentDataSource;

  constructor(dataSource: AmplitudeExperimentDataSource) {
    super();
    this.dataSource = dataSource;
  }

  async getFlag(key: string): Promise<Either<Error, FeatureFlag>> {
    try {
      const { value } = this.dataSource.getVariant(key);
      const enabled = value === VARIANT_TREATMENT;
      return Right(new FeatureFlag(key, enabled, value));
    } catch (e) {
      return Left(e instanceof Error ? e : new Error(String(e)));
    }
  }
}
